export default __webpack_public_path__ + "static/media/chengdu.c6477e88.jpg";